import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 查询玩家列表
const findByWord = obj => new Promise((resolve, reject) => {
    const {
        wordForm,
        token
    } = obj
    request({
        url: apis.maskword_find + '?token=' + token,
        data: wordForm
    }).then(res => {
        resolve(res);
    })
})

const appendWord = obj => new Promise((resolve, reject) => {
    const {
        wordForm,
        token
    } = obj
    request({
        url: apis.maskword_append + '?token=' + token,
        data: wordForm
    }).then(res => {
        resolve(res);
    })
})

const delWord = obj => new Promise((resolve, reject) => {
    const {
        wordForm,
        token
    } = obj
    request({
        url: apis.maskword_del + '?token=' + token ,
        data: wordForm
    }).then(res => {
        resolve(res);
    })
})

const refreshWord = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj
    request({
        url: apis.maskword_refresh + '?token=' + token
    }).then(res => {
        resolve(res);
    })
})

export default {
    findByWord,
    appendWord,
    delWord,
    refreshWord
}



// WEBPACK FOOTER //
// ./src/service/maskword_api.js